import React, { useMemo } from 'react';

// Static star positions and properties
const STATIC_STARS = [
  // Extra large stars (card-sized) - increased opacity and glow
  { left: '15%', top: '20%', size: 'text-[4rem]', opacity: 0.4, duration: 8, glow: '0 0 10px rgba(255, 255, 255, 0.5)' },
  { left: '75%', top: '15%', size: 'text-[3.5rem]', opacity: 0.35, duration: 10, glow: '0 0 8px rgba(255, 255, 255, 0.5)' },
  { left: '85%', top: '75%', size: 'text-[4rem]', opacity: 0.45, duration: 12, glow: '0 0 10px rgba(255, 255, 255, 0.5)' },
  
  // Large stars - moderate brightness
  { left: '25%', top: '65%', size: 'text-[2rem]', opacity: 0.3, duration: 6, glow: '0 0 6px rgba(255, 255, 255, 0.4)' },
  { left: '60%', top: '85%', size: 'text-[2.5rem]', opacity: 0.35, duration: 7, glow: '0 0 7px rgba(255, 255, 255, 0.4)' },
  { left: '80%', top: '35%', size: 'text-[2rem]', opacity: 0.3, duration: 8, glow: '0 0 6px rgba(255, 255, 255, 0.4)' },
  
  // Medium stars - original brightness
  { left: '40%', top: '25%', size: 'text-xl', opacity: 0.3, duration: 5, glow: '0 0 4px rgba(255, 255, 255, 0.3)' },
  { left: '70%', top: '45%', size: 'text-xl', opacity: 0.25, duration: 6, glow: '0 0 4px rgba(255, 255, 255, 0.3)' },
  { left: '30%', top: '80%', size: 'text-xl', opacity: 0.3, duration: 4, glow: '0 0 4px rgba(255, 255, 255, 0.3)' },
  { left: '85%', top: '15%', size: 'text-xl', opacity: 0.25, duration: 5, glow: '0 0 4px rgba(255, 255, 255, 0.3)' },
  
  // Small stars - subtle glow
  { left: '10%', top: '40%', size: 'text-[8px]', opacity: 0.4, duration: 4, glow: '0 0 2px rgba(255, 255, 255, 0.2)' },
  { left: '45%', top: '70%', size: 'text-[8px]', opacity: 0.35, duration: 5, glow: '0 0 2px rgba(255, 255, 255, 0.2)' },
  { left: '90%', top: '60%', size: 'text-[8px]', opacity: 0.4, duration: 3, glow: '0 0 2px rgba(255, 255, 255, 0.2)' },
  { left: '20%', top: '30%', size: 'text-[8px]', opacity: 0.35, duration: 4, glow: '0 0 2px rgba(255, 255, 255, 0.2)' },
  { left: '65%', top: '25%', size: 'text-[8px]', opacity: 0.4, duration: 5, glow: '0 0 2px rgba(255, 255, 255, 0.2)' },
  { left: '75%', top: '90%', size: 'text-[8px]', opacity: 0.35, duration: 4, glow: '0 0 2px rgba(255, 255, 255, 0.2)' }
];

const StarCanvas = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {STATIC_STARS.map((star, index) => (
        <div
          key={index}
          className={`absolute text-white ${star.size} animate-spin`}
          style={{
            left: star.left,
            top: star.top,
            opacity: star.opacity,
            animationDuration: `${star.duration}s`,
            animationTimingFunction: 'linear',
            animationIterationCount: 'infinite',
            textShadow: star.glow
          }}
        >
          ✧
        </div>
      ))}
    </div>
  );
};

export default StarCanvas; 